import { Auth0Provider } from '@auth0/auth0-react';
import type { AppState } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth0Config } from '../config/auth0';

interface CustomAuth0ProviderProps {
  children: ReactNode;
}

export const CustomAuth0Provider = ({ children }: CustomAuth0ProviderProps) => {
  const navigate = useNavigate();
  const authorizationParams: any = {
    redirect_uri: auth0Config.redirectUri,
    scope: auth0Config.scope,
  };
  
  if (auth0Config.audience && !auth0Config.audience.includes('/api/v2/')) {
    authorizationParams.audience = auth0Config.audience;
  }

  const handleRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || '/welcome', { replace: true });
  };
  
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={authorizationParams}
      useRefreshTokens={auth0Config.useRefreshTokens}
      cacheLocation={auth0Config.cacheLocation}
      onRedirectCallback={handleRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
